
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13519",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13519",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1138",
  "client-types": "static-1.511",
  "data-fetching-client": "static-1.10119",
  "foundations-components": "static-1.8756",
  "foundations-components-legacy": "static-1.1781",
  "foundations-theming": "static-1.4967",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.93",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8517",
  "hub-http-shared-msw-handlers": "static-1.10912",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11966",
  "I18n": "static-7.1708",
  "jasmine-runner": "static-1.6930",
  "marketplace-discovery-studio-lib": "static-1.913",
  "marketplace-storefront-base": "static-1.13582",
  "quartz": "static-1.7661",
  "react-dlb": "static-1.93",
  "react-rhumb": "static-1.17216",
  "reactive-variable-buffer-atom": "static-1.3331",
  "reporting-testing-lib": "static-1.11296",
  "reselect": "static-3.16",
  "settings-ui-lib": "static-1.13006",
  "SharedI18nStrings": "static-1.187",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7856",
  "ui-addon-i18n": "static-1.11624",
  "ui-addon-react-router-dom": "static-1.10003",
  "unified-auth": "static-1.1267",
  "unified-auth-core-lib": "static-1.1549",
  "usage-tracker": "static-1.7803",
  "usage-tracker-core": "static-1.7653",
  "customer-data-property-utils": "static-1.8530",
  "hub-http": "static-1.6685",
  "integrations-lib": "static-1.17439",
  "marketplace-ui-common": "static-1.21050",
  "marketplace-ui-install": "static-1.1036",
  "property-management-iframe": "static-1.14465",
  "quartz-config": "static-1.1439",
  "quartz-core": "static-1.6880",
  "quartz-routing": "static-1.1091",
  "quick-fetch": "static-1.4233",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5148",
  "ts-schema": "static-1.4395",
  "ui-universal-auth": "static-1.9753",
  "UIComponents": "static-3.8912",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3938",
  "quartz-webpack": "static-1.3885",
  "bend-plugin-quartz-routing": "static-1.739",
  "ai-components-ui-library": "static-1.10028",
  "codemirror": "static-5.106",
  "foundations-assets": "static-1.5364",
  "pulse": "static-1.1126",
  "react-codemirror": "static-1.11120",
  "ui-extensions-preview-lib": "static-1.974",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5025",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2683",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9906",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.103",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5658",
  "react-virtualized": "static-2.112",
  "StyleGuideUI": "static-3.518",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3098",
  "ui-fonts": "static-1.1228",
  "ui-images": "static-2.1277",
  "bend-plugin-foundations-theming": "static-1.3450",
  "foundations-theming-base": "static-1.3952",
  "stylex": "static-1.46",
  "HeadJS": "static-2.822",
  "hs-test-utils-bend-plugin": "static-1.3628",
  "msw": "static-1.102",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4786",
  "ui-addon-video-player": "static-1.9102",
  "ai-rendering-library": "static-1.11408",
  "chirp-fetch": "static-1.2383",
  "connections-embed-lib": "static-1.1757",
  "copilot-toolkit": "static-1.12158",
  "feedback-loader": "static-1.30069",
  "laboratory-lib": "static-3.7625",
  "marketplace-embed": "static-1.23211",
  "marketplace-ui-details": "static-1.10945",
  "marketplace-ui-reviews": "static-1.21005",
  "marketplace-ui-tracking": "static-1.15220",
  "sanitize-text": "static-1.8637",
  "usage-tracker-multi": "static-1.6217",
  "usage-tracker-session-replay": "static-1.5489",
  "beacon-keepalive-queue": "static-1.179",
  "quartz-head": "static-1.1326",
  "web-vitals": "static-1.19",
  "apollo-link-hub-http": "static-2.5066",
  "immer": "static-1.105",
  "immerable": "static-1.4620",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2839",
  "reporting-data": "static-1.69363",
  "cssUtils": "static-1.1101",
  "flux-actions": "static-1.380",
  "react-colorpicker": "static-2.10688",
  "react-dnd-compat": "static-1.5088",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10849",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7793",
  "icons": "static-2.703",
  "marketplace-ui-apps-core": "static-1.19582",
  "storybook-react": "static-1.44",
  "trellis-story-utils": "static-1.4977",
  "foundations-components-test-utils": "static-1.6239",
  "quartz-i18n": "static-1.1336",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.772",
  "ads-unified-auth-lib": "static-1.1988",
  "ai-mcp-auth-lib": "static-1.22",
  "custom-vendor-connection-lib": "static-1.317",
  "google-sheets-integration-lib": "static-1.1340",
  "microsoft-drive-auth-lib": "static-1.517",
  "slack-ui-library": "static-1.10877",
  "surveymonkey-integration-lib": "static-1.875",
  "fsm": "static-1.4236",
  "customer-data-objects": "static-1.8184",
  "property-translator": "static-1.5859",
  "hs-locale-management": "static-1.402",
  "frontend-preferences-client": "static-1.8399",
  "hs-promise-utils": "static-1.6071",
  "hubspot-apollo-client": "static-1.5360",
  "integrations-error-boundary-lib": "static-1.14854",
  "integrations-tracking-lib": "static-1.6100",
  "native-integrations-shared-strings": "static-1.8242",
  "sanitize": "static-1.4953",
  "superstore": "static-1.5238",
  "ui-shepherd-react": "static-3.10757",
  "ai-settings-ui-library": "static-1.8594",
  "hub-http-janus": "static-1.907",
  "hubspotter-http": "static-1.4977",
  "immutable-less": "static-1.5131",
  "marketplace-ui-client-types": "static-1.18457",
  "nav-meta": "static-1.30813",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18548",
  "ui-product-approvals-common": "static-1.1589",
  "ai-studio-lib": "static-1.12774",
  "hubspot-prosemirror": "static-1.19288",
  "integrations-reconnect-lib": "static-1.730",
  "ui-addon-iframeable": "static-1.9554",
  "ui-addon-integrations-directory-panel": "static-2.8432",
  "ui-product-approvals": "static-1.29694",
  "ui-tool-access": "static-1.10638",
  "inbound-db-properties-service-client": "static-1.4153",
  "property-management-common": "static-1.6753",
  "opentelemetry-fe-types": "static-1.270",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.645",
  "quartz-auth": "static-1.1336",
  "quartz-test": "static-1.1336",
  "quartz-tracking": "static-1.1040",
  "trellis-components": "static-1.3117",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.558",
  "HubStyle": "static-2.12273",
  "bender-build-tools": "static-1.3600",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23910",
  "ContentUtils": "static-1.69483",
  "customer-data-objects-ui-components": "static-1.13515",
  "sassPrefix": "static-1.367",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2027",
  "bend-plugin-pulse": "static-1.629",
  "event-emitter": "static-1.1440",
  "fast-json-patch": "static-1.74",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5910",
  "magpie-types": "static-1.5370",
  "stylex-utils": "static-1.175",
  "trellis-theming": "static-1.1486",
  "avatar-components": "static-1.2964",
  "breeze-engine-core": "static-1.1476",
  "breeze-engine-lib": "static-1.2198",
  "breeze-onboarding-components": "static-1.1073",
  "customer-data-filters-ui": "static-1.41377",
  "customer-data-reference-ui-components": "static-1.13654",
  "data-integrations-breeze": "static-1.321",
  "embedded-academy-lib": "static-1.16017",
  "ExportDialog": "static-6.10852",
  "global-styles-ai-lib": "static-1.497",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.914",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.44",
  "reporting-action-components": "static-1.42416",
  "reporting-snowflake": "static-1.57979",
  "reporting-ui-components": "static-2.66632",
  "reporting-visualizations": "static-1.61437",
  "trial-components-library": "static-1.14383",
  "ui-addon-teams": "static-1.22015",
  "upgrade-components-lib": "static-1.726",
  "navigation-components": "static-1.19176",
  "nest": "static-1.714",
  "simple-logging-lib": "static-1.3530",
  "nudge-client-utils": "static-1.3430",
  "fail-safe": "static-1.428",
  "app-governance-lib": "static-1.2744",
  "developer-experience-shared-components": "static-1.11018",
  "purchase-motions-components": "static-1.6637",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10798",
  "usage-tracker-anonymous": "static-1.6220",
  "usage-tracker-public": "static-1.7614",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3776",
  "persist-promise": "static-1.4184",
  "reference-resolvers": "static-1.8662",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4394",
  "hubspot-apollo-cache": "static-1.819",
  "universal-page-editor-lib": "static-1.3490",
  "final-form": "static-1.83",
  "redux-toolkit": "static-1.82",
  "simple-data-table": "static-1.3831",
  "merchandise-lib": "static-1.284",
  "onboarding-scopes": "static-1.6931",
  "ui-addon-draggable": "static-3.5227",
  "content-assistance-lib": "static-1.8430",
  "content-media-capture": "static-1.5802",
  "customer-data-ui-utilities": "static-1.10310",
  "emoji-mart": "static-3.7",
  "file-manager-components": "static-1.24852",
  "growth-payments-core": "static-1.26511",
  "knowledge-content-types": "static-1.8763",
  "PatternValidationJS": "static-1.3364",
  "payment-link-components": "static-1.24464",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20562",
  "ui-addon-emoji-picker": "static-1.10342",
  "ui-business-units-lib": "static-1.9574",
  "video-components-external": "static-1.12440",
  "video-data-lib": "static-1.36098",
  "navigation-messaging": "static-1.8503",
  "collaboration-sidebar": "static-1.59062",
  "trellis-ext-dnd": "static-1.552",
  "crm-component-utils": "static-1.40198",
  "crm-properties-common-lib": "static-1.6375",
  "customer-data-properties": "static-1.53062",
  "external-options-client-types": "static-1.4441",
  "framework-data-schema-resolvers": "static-1.7371",
  "hs-resources": "static-1.667",
  "property-value-citations": "static-1.3676",
  "reference-resolvers-lite": "static-1.8592",
  "opentelemetry-web": "static-1.22",
  "hubspotter-http-shared-msw-handlers": "static-1.10910",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "cms-field-types": "static-1.5289",
  "content-icons-ui": "static-1.2460",
  "atom": "static-1.5551",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1198",
  "trellis-migration-context": "static-1.59",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1176",
  "breeze-artifacts-sdk": "static-1.972",
  "getting-started-shared-tasks": "static-1.19572",
  "onboarding-journeys-lib": "static-1.1242",
  "conversations-skeleton-state": "static-1.7608",
  "crm-message-bus": "static-1.44116",
  "customer-data-filters-ui-msw-helpers": "static-1.23812",
  "events-data-lib": "static-1.724",
  "FormUrlGenerator": "static-2.5191",
  "framework-builder-read-service-client": "static-1.4337",
  "multi-account-reference-resolvers": "static-1.1488",
  "onboarding-tours": "static-1.17410",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14778",
  "segments-client-types": "static-1.12163",
  "academy-common-lib": "static-1.15478",
  "dashboard-lib": "static-1.83317",
  "hubspot-prosemirror-plugins": "static-1.19280",
  "share-with-third-party-component-lib": "static-1.9190",
  "ui-asset-management-lib": "static-1.11579",
  "user-context": "static-1.5532",
  "reporting-plugins": "static-1.10994",
  "reporting-reports": "static-1.69039",
  "hubs-service-types": "static-1.1747",
  "purchase-motions-api": "static-1.6640",
  "salesImages": "static-1.736",
  "signup-constants": "static-1.19951",
  "nudge-custom-function-registry": "static-1.3187",
  "nudge-renderer-utils": "static-1.3506",
  "whisper-core-api": "static-1.7644",
  "bend-plugin-fail-safe": "static-1.379",
  "framework-listing-lib": "static-2.29806",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31768",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4616",
  "signup-ui-url-generator": "static-2.8520",
  "onboarding-tours-client": "static-1.5625",
  "one-click-checkout": "static-1.750",
  "platform-infra-nav-components": "static-1.8004",
  "subscription-experience-data-types": "static-1.15442",
  "crm-record-cards-service-types": "static-1.3871",
  "location-customization-utils-lib": "static-1.10430",
  "redux-thunk": "static-2.84",
  "react-flip-move": "static-1.83",
  "ui-coaching-tips": "static-1.29587",
  "content-media-composition-data-lib": "static-1.13606",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4906",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3956",
  "seat-types-lib": "static-1.1062",
  "ui-addon-opt": "static-4.8888",
  "commerce-tours-lib": "static-1.6870",
  "growth-onboarding-reliability": "static-1.5562",
  "sales-checkout-service-client": "static-1.3999",
  "data-token-picker": "static-1.17142",
  "FileManagerLib": "static-1.40492",
  "content-media-compositions": "static-2.17613",
  "media-bridge-lib": "static-1.19649",
  "chatspot-widget-iframe": "static-1.23901",
  "collaboration-sidebar-common": "static-1.3859",
  "marketing-platform-lib": "static-1.7386",
  "dnd-kit": "static-1.21",
  "commerce-subscription-lib": "static-1.38062",
  "crm-actions": "static-1.6851",
  "crm-cards-sdk": "static-1.45035",
  "customer-data-properties-shared-msw-handlers": "static-1.10239",
  "customer-data-tracking": "static-1.7349",
  "calling-global-api": "static-1.66206",
  "calling-internal-common": "static-1.31804",
  "calling-lifecycle-internal": "static-1.67588",
  "calling-lifecycle-messages": "static-1.59880",
  "commerce-products-lib": "static-1.10927",
  "conditional-properties-service-client": "static-1.4115",
  "crm-index-visualization-core": "static-1.4763",
  "crm-links": "static-1.6791",
  "crm-pipelines-api-client-types": "static-1.4445",
  "formula-editor": "static-1.15019",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1110",
  "multi-currency-client-types": "static-1.4009",
  "object-builder-ui-client": "static-1.50057",
  "pipeline-validation-client-types": "static-1.4283",
  "smart-data-capture-core": "static-1.482",
  "smart-property-lib": "static-1.8667",
  "tiered-pricing": "static-1.2287",
  "topics-actions-lib": "static-1.662",
  "trellis-ext-i18n": "static-1.1396",
  "ui-addon-form-validation": "static-1.11348",
  "zustand": "static-1.89",
  "fdsr-migration-layer": "static-1.490",
  "framework-data-schema-quick-fetch": "static-1.7276",
  "restore-request-side-panel-lib": "static-1.2035",
  "growth-data-modal": "static-1.6141",
  "growth-onboarding-confetti": "static-1.3537",
  "growth-onboarding-next-action-utils": "static-1.2992",
  "onboarding-tours-utils": "static-1.1477",
  "ui-shepherd-tracker": "static-1.8138",
  "crm-index-associations-lib": "static-1.6928",
  "academy-service-client": "static-1.4171",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40351",
  "SafeStorage": "static-1.4875",
  "video-embed": "static-1.36932",
  "wootric-nps": "static-1.7298",
  "redux-actions": "static-3.74",
  "EmailSignatureEditor": "static-1.25256",
  "viral-links-lib": "static-1.7560",
  "nested-table": "static-1.711",
  "timezone-utils": "static-2.5708",
  "getting-started-shared-tasks-store": "static-1.18690",
  "campaign-roi-lib": "static-1.10835",
  "campaigns-utils-lib": "static-1.3725",
  "ui-addon-calendars": "static-2.5843",
  "customer-data-views-management": "static-1.26363",
  "framework-data-table": "static-2.12847",
  "nudge-custom-ui-functions": "static-1.1748",
  "switchboard-lib": "static-1.716",
  "access-check-ui-lib": "static-1.1891",
  "app-users-service-client": "static-1.6099",
  "app-users-service-types": "static-1.5507",
  "mini-checkout-client": "static-1.27845",
  "onboarding-utils": "static-1.5852",
  "permissions-shared-i18n-strings-fe": "static-1.2143",
  "ui-coaching-tips-shared-config": "static-1.29572",
  "checkout-sdk": "static-3.24688",
  "payment-method-components": "static-1.7321",
  "touchless-buying-components": "static-1.6556",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.870",
  "growth-onboarding-feedback-components": "static-1.7059",
  "audio-components": "static-1.6578",
  "FileManagerImages": "static-1.38003",
  "video-components": "static-1.14442",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20499",
  "commerce-shared-components-lib": "static-1.19574",
  "commerce-tools-ui-lib": "static-1.11330",
  "crm_data": "static-4.93214",
  "crm-activity-creator-data": "static-1.47736",
  "crm-fe-perf": "static-1.23378",
  "universal-record-utils-lib": "static-1.2373",
  "calling-error-reporting": "static-1.31811",
  "shared-worker-versioning": "static-1.11520",
  "calling-usage-tracker": "static-1.7018",
  "voice-sms-access-library": "static-1.2460",
  "commerce-permissions": "static-1.1263",
  "products-iframe-lib": "static-1.8915",
  "products-ui-components-shared-msw-handlers": "static-1.11294",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10995",
  "sales-views-client-types": "static-1.4736",
  "bark-lib": "static-1.17009",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.924",
  "data-agent-test-utils": "static-1.468",
  "data-agent-utils": "static-1.937",
  "policy-lib": "static-1.7283",
  "react-tinymce": "static-1.56277",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11058",
  "tinymce-config": "static-2.55403",
  "tinymce-plugins": "static-1.58517",
  "onboarding-data-sync-lib": "static-1.2847",
  "growth-onboarding-next-action-components": "static-1.3020",
  "user-context-client": "static-1.4988",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4993",
  "outpost": "static-1.4607",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22365",
  "sales-email-signature-service-client": "static-1.4326",
  "ts-utils-lib": "static-1.629",
  "copilot-messaging": "static-1.2408",
  "crm-export-dialog": "static-1.6757",
  "crm-index-ui-shimmer": "static-1.2979",
  "crm-view-components": "static-1.1499",
  "react-beautiful-dnd": "static-1.75",
  "customer-data-associations": "static-1.7817",
  "tasks-actions-lib": "static-1.441",
  "InboxConnectUtils": "static-4.15851",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.879",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4465",
  "company-details-components": "static-1.6685",
  "react-performance-metrics-lib": "static-1.1031",
  "pricing-pages-ui-components": "static-1.16571",
  "quote-checkout-service-types": "static-1.3938",
  "social-insights-client-types": "static-1.22939",
  "utility-belt": "static-1.3016",
  "payments-enrollment-embed-lib": "static-1.24213",
  "stripe-embedded-components": "static-1.8253",
  "customer-data-rte": "static-1.33909",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6542",
  "payments-post-enroll-local-storage-lib": "static-1.5583",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39178",
  "crm_universal": "static-1.22733",
  "customer-data-email": "static-1.18649",
  "meetings-rte-lib": "static-1.550",
  "universal-associations-select": "static-1.11574",
  "crm-object-search-query-utilities": "static-1.10466",
  "calling-orchestration-schema": "static-1.37237",
  "react-reducer-toolkit": "static-1.16677",
  "enrichment-settings-lib": "static-1.242",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57373",
  "hub-http-contrib": "static-1.3511",
  "interframe": "static-3.5220",
  "tinymce-data": "static-1.41488",
  "ui-addon-sales-email": "static-1.5680",
  "layout-dnd-components": "static-1.13236",
  "layout-dnd-utils": "static-1.12211",
  "ui-brand-identity-lib": "static-1.16960",
  "meetings-connect-utils-lib": "static-1.8097",
  "company-details-service-types": "static-1.4423",
  "segments-query-core": "static-1.1909",
  "pricing-pages-api": "static-1.16436",
  "stripe-connect-js": "static-1.82",
  "draft-content-plugins": "static-1.29164",
  "sequences-lib": "static-1.8795",
  "ui-gdpr-components": "static-1.10656",
  "meetings-client-types": "static-1.4067",
  "meetings-core": "static-1.772",
  "NamespacedHubStyle": "static-2.9369",
  "ContentData": "static-1.69558",
  "layout-data-lib": "static-1.10536",
  "sequences-client-types-lib": "static-1.8652",
  "advanced-menus-core": "static-1.15823",
  "advanced-menus-lib": "static-1.12574",
  "ui-memberships-settings-lib": "static-1.35203",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15822",
  "simple-menus-lib": "static-1.17339"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13519",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1138",
  "client-types": "/client-types/static-1.511",
  "data-fetching-client": "/data-fetching-client/static-1.10119",
  "foundations-components": "/foundations-components/static-1.8756",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1781",
  "foundations-theming": "/foundations-theming/static-1.4967",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.93",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8517",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10912",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11966",
  "I18n": "/I18n/static-7.1708",
  "jasmine-runner": "/jasmine-runner/static-1.6930",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.913",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13582",
  "quartz": "/quartz/static-1.7661",
  "react-dlb": "/react-dlb/static-1.93",
  "react-rhumb": "/react-rhumb/static-1.17216",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3331",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11296",
  "reselect": "/reselect/static-3.16",
  "settings-ui-lib": "/settings-ui-lib/static-1.13006",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7856",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11624",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10003",
  "unified-auth": "/unified-auth/static-1.1267",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1549",
  "usage-tracker": "/usage-tracker/static-1.7803",
  "usage-tracker-core": "/usage-tracker-core/static-1.7653",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8530",
  "hub-http": "/hub-http/static-1.6685",
  "integrations-lib": "/integrations-lib/static-1.17439",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1036",
  "property-management-iframe": "/property-management-iframe/static-1.14465",
  "quartz-config": "/quartz-config/static-1.1439",
  "quartz-core": "/quartz-core/static-1.6880",
  "quartz-routing": "/quartz-routing/static-1.1091",
  "quick-fetch": "/quick-fetch/static-1.4233",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5148",
  "ts-schema": "/ts-schema/static-1.4395",
  "ui-universal-auth": "/ui-universal-auth/static-1.9753",
  "UIComponents": "/UIComponents/static-3.8912",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3938",
  "quartz-webpack": "/quartz-webpack/static-1.3885",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.739",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10028",
  "codemirror": "/codemirror/static-5.106",
  "foundations-assets": "/foundations-assets/static-1.5364",
  "pulse": "/pulse/static-1.1126",
  "react-codemirror": "/react-codemirror/static-1.11120",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.974",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5025",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2683",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9906",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5658",
  "react-virtualized": "/react-virtualized/static-2.112",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3098",
  "ui-fonts": "/ui-fonts/static-1.1228",
  "ui-images": "/ui-images/static-2.1277",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3450",
  "foundations-theming-base": "/foundations-theming-base/static-1.3952",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.822",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3628",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4786",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9102",
  "ai-rendering-library": "/ai-rendering-library/static-1.11408",
  "chirp-fetch": "/chirp-fetch/static-1.2383",
  "connections-embed-lib": "/connections-embed-lib/static-1.1757",
  "copilot-toolkit": "/copilot-toolkit/static-1.12158",
  "feedback-loader": "/feedback-loader/static-1.30069",
  "laboratory-lib": "/laboratory-lib/static-3.7625",
  "marketplace-embed": "/marketplace-embed/static-1.23211",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10945",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21005",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15220",
  "sanitize-text": "/sanitize-text/static-1.8637",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6217",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5489",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.179",
  "quartz-head": "/quartz-head/static-1.1326",
  "web-vitals": "/web-vitals/static-1.19",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5066",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4620",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2839",
  "reporting-data": "/reporting-data/static-1.69363",
  "cssUtils": "/cssUtils/static-1.1101",
  "flux-actions": "/flux-actions/static-1.380",
  "react-colorpicker": "/react-colorpicker/static-2.10688",
  "react-dnd-compat": "/react-dnd-compat/static-1.5088",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10849",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7793",
  "icons": "/icons/static-2.703",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "storybook-react": "/storybook-react/static-1.44",
  "trellis-story-utils": "/trellis-story-utils/static-1.4977",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6239",
  "quartz-i18n": "/quartz-i18n/static-1.1336",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.772",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1988",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.22",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.317",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1340",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.517",
  "slack-ui-library": "/slack-ui-library/static-1.10877",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.875",
  "fsm": "/fsm/static-1.4236",
  "customer-data-objects": "/customer-data-objects/static-1.8184",
  "property-translator": "/property-translator/static-1.5859",
  "hs-locale-management": "/hs-locale-management/static-1.402",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8399",
  "hs-promise-utils": "/hs-promise-utils/static-1.6071",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5360",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14854",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6100",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8242",
  "sanitize": "/sanitize/static-1.4953",
  "superstore": "/superstore/static-1.5238",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10757",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8594",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hubspotter-http": "/hubspotter-http/static-1.4977",
  "immutable-less": "/immutable-less/static-1.5131",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "nav-meta": "/nav-meta/static-1.30813",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18548",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1589",
  "ai-studio-lib": "/ai-studio-lib/static-1.12774",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19288",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.730",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9554",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8432",
  "ui-product-approvals": "/ui-product-approvals/static-1.29694",
  "ui-tool-access": "/ui-tool-access/static-1.10638",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4153",
  "property-management-common": "/property-management-common/static-1.6753",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.270",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.645",
  "quartz-auth": "/quartz-auth/static-1.1336",
  "quartz-test": "/quartz-test/static-1.1336",
  "quartz-tracking": "/quartz-tracking/static-1.1040",
  "trellis-components": "/trellis-components/static-1.3117",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.558",
  "HubStyle": "/HubStyle/static-2.12273",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23910",
  "ContentUtils": "/ContentUtils/static-1.69483",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13515",
  "sassPrefix": "/sassPrefix/static-1.367",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2027",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.629",
  "event-emitter": "/event-emitter/static-1.1440",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5910",
  "magpie-types": "/magpie-types/static-1.5370",
  "stylex-utils": "/stylex-utils/static-1.175",
  "trellis-theming": "/trellis-theming/static-1.1486",
  "avatar-components": "/avatar-components/static-1.2964",
  "breeze-engine-core": "/breeze-engine-core/static-1.1476",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2198",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1073",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41377",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13654",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.321",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16017",
  "ExportDialog": "/ExportDialog/static-6.10852",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.497",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.914",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.44",
  "reporting-action-components": "/reporting-action-components/static-1.42416",
  "reporting-snowflake": "/reporting-snowflake/static-1.57979",
  "reporting-ui-components": "/reporting-ui-components/static-2.66632",
  "reporting-visualizations": "/reporting-visualizations/static-1.61437",
  "trial-components-library": "/trial-components-library/static-1.14383",
  "ui-addon-teams": "/ui-addon-teams/static-1.22015",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.726",
  "navigation-components": "/navigation-components/static-1.19176",
  "nest": "/nest/static-1.714",
  "simple-logging-lib": "/simple-logging-lib/static-1.3530",
  "nudge-client-utils": "/nudge-client-utils/static-1.3430",
  "fail-safe": "/fail-safe/static-1.428",
  "app-governance-lib": "/app-governance-lib/static-1.2744",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11018",
  "purchase-motions-components": "/purchase-motions-components/static-1.6637",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10798",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6220",
  "usage-tracker-public": "/usage-tracker-public/static-1.7614",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3776",
  "persist-promise": "/persist-promise/static-1.4184",
  "reference-resolvers": "/reference-resolvers/static-1.8662",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4394",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.819",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3490",
  "final-form": "/final-form/static-1.83",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "simple-data-table": "/simple-data-table/static-1.3831",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "onboarding-scopes": "/onboarding-scopes/static-1.6931",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5227",
  "content-assistance-lib": "/content-assistance-lib/static-1.8430",
  "content-media-capture": "/content-media-capture/static-1.5802",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10310",
  "emoji-mart": "/emoji-mart/static-3.7",
  "file-manager-components": "/file-manager-components/static-1.24852",
  "growth-payments-core": "/growth-payments-core/static-1.26511",
  "knowledge-content-types": "/knowledge-content-types/static-1.8763",
  "PatternValidationJS": "/PatternValidationJS/static-1.3364",
  "payment-link-components": "/payment-link-components/static-1.24464",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20562",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10342",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9574",
  "video-components-external": "/video-components-external/static-1.12440",
  "video-data-lib": "/video-data-lib/static-1.36098",
  "navigation-messaging": "/navigation-messaging/static-1.8503",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59062",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.552",
  "crm-component-utils": "/crm-component-utils/static-1.40198",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6375",
  "customer-data-properties": "/customer-data-properties/static-1.53062",
  "external-options-client-types": "/external-options-client-types/static-1.4441",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7371",
  "hs-resources": "/hs-resources/static-1.667",
  "property-value-citations": "/property-value-citations/static-1.3676",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8592",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10910",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "cms-field-types": "/cms-field-types/static-1.5289",
  "content-icons-ui": "/content-icons-ui/static-1.2460",
  "atom": "/atom/static-1.5551",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1198",
  "trellis-migration-context": "/trellis-migration-context/static-1.59",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1176",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.972",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19572",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1242",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "crm-message-bus": "/crm-message-bus/static-1.44116",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23812",
  "events-data-lib": "/events-data-lib/static-1.724",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5191",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4337",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1488",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14778",
  "segments-client-types": "/segments-client-types/static-1.12163",
  "academy-common-lib": "/academy-common-lib/static-1.15478",
  "dashboard-lib": "/dashboard-lib/static-1.83317",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19280",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9190",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11579",
  "user-context": "/user-context/static-1.5532",
  "reporting-plugins": "/reporting-plugins/static-1.10994",
  "reporting-reports": "/reporting-reports/static-1.69039",
  "hubs-service-types": "/hubs-service-types/static-1.1747",
  "purchase-motions-api": "/purchase-motions-api/static-1.6640",
  "salesImages": "/salesImages/static-1.736",
  "signup-constants": "/signup-constants/static-1.19951",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3187",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3506",
  "whisper-core-api": "/whisper-core-api/static-1.7644",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.379",
  "framework-listing-lib": "/framework-listing-lib/static-2.29806",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31768",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4616",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "one-click-checkout": "/one-click-checkout/static-1.750",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8004",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15442",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10430",
  "redux-thunk": "/redux-thunk/static-2.84",
  "react-flip-move": "/react-flip-move/static-1.83",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29587",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13606",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4906",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3956",
  "seat-types-lib": "/seat-types-lib/static-1.1062",
  "ui-addon-opt": "/ui-addon-opt/static-4.8888",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6870",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5562",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3999",
  "data-token-picker": "/data-token-picker/static-1.17142",
  "FileManagerLib": "/FileManagerLib/static-1.40492",
  "content-media-compositions": "/content-media-compositions/static-2.17613",
  "media-bridge-lib": "/media-bridge-lib/static-1.19649",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23901",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3859",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7386",
  "dnd-kit": "/dnd-kit/static-1.21",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38062",
  "crm-actions": "/crm-actions/static-1.6851",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45035",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10239",
  "customer-data-tracking": "/customer-data-tracking/static-1.7349",
  "calling-global-api": "/calling-global-api/static-1.66206",
  "calling-internal-common": "/calling-internal-common/static-1.31804",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67588",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59880",
  "commerce-products-lib": "/commerce-products-lib/static-1.10927",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4115",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4763",
  "crm-links": "/crm-links/static-1.6791",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4445",
  "formula-editor": "/formula-editor/static-1.15019",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1110",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4009",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50057",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4283",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.482",
  "smart-property-lib": "/smart-property-lib/static-1.8667",
  "tiered-pricing": "/tiered-pricing/static-1.2287",
  "topics-actions-lib": "/topics-actions-lib/static-1.662",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1396",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "zustand": "/zustand/static-1.89",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.490",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7276",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2035",
  "growth-data-modal": "/growth-data-modal/static-1.6141",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3537",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2992",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8138",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6928",
  "academy-service-client": "/academy-service-client/static-1.4171",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40351",
  "SafeStorage": "/SafeStorage/static-1.4875",
  "video-embed": "/video-embed/static-1.36932",
  "wootric-nps": "/wootric-nps/static-1.7298",
  "redux-actions": "/redux-actions/static-3.74",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25256",
  "viral-links-lib": "/viral-links-lib/static-1.7560",
  "nested-table": "/nested-table/static-1.711",
  "timezone-utils": "/timezone-utils/static-2.5708",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18690",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10835",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3725",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5843",
  "customer-data-views-management": "/customer-data-views-management/static-1.26363",
  "framework-data-table": "/framework-data-table/static-2.12847",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1748",
  "switchboard-lib": "/switchboard-lib/static-1.716",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1891",
  "app-users-service-client": "/app-users-service-client/static-1.6099",
  "app-users-service-types": "/app-users-service-types/static-1.5507",
  "mini-checkout-client": "/mini-checkout-client/static-1.27845",
  "onboarding-utils": "/onboarding-utils/static-1.5852",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2143",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29572",
  "checkout-sdk": "/checkout-sdk/static-3.24688",
  "payment-method-components": "/payment-method-components/static-1.7321",
  "touchless-buying-components": "/touchless-buying-components/static-1.6556",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.870",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7059",
  "audio-components": "/audio-components/static-1.6578",
  "FileManagerImages": "/FileManagerImages/static-1.38003",
  "video-components": "/video-components/static-1.14442",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20499",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19574",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11330",
  "crm_data": "/crm_data/static-4.93214",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47736",
  "crm-fe-perf": "/crm-fe-perf/static-1.23378",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2373",
  "calling-error-reporting": "/calling-error-reporting/static-1.31811",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11520",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7018",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2460",
  "commerce-permissions": "/commerce-permissions/static-1.1263",
  "products-iframe-lib": "/products-iframe-lib/static-1.8915",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11294",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10995",
  "sales-views-client-types": "/sales-views-client-types/static-1.4736",
  "bark-lib": "/bark-lib/static-1.17009",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.924",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.468",
  "data-agent-utils": "/data-agent-utils/static-1.937",
  "policy-lib": "/policy-lib/static-1.7283",
  "react-tinymce": "/react-tinymce/static-1.56277",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11058",
  "tinymce-config": "/tinymce-config/static-2.55403",
  "tinymce-plugins": "/tinymce-plugins/static-1.58517",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2847",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3020",
  "user-context-client": "/user-context-client/static-1.4988",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4993",
  "outpost": "/outpost/static-1.4607",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22365",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4326",
  "ts-utils-lib": "/ts-utils-lib/static-1.629",
  "copilot-messaging": "/copilot-messaging/static-1.2408",
  "crm-export-dialog": "/crm-export-dialog/static-1.6757",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2979",
  "crm-view-components": "/crm-view-components/static-1.1499",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.75",
  "customer-data-associations": "/customer-data-associations/static-1.7817",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.441",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15851",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.879",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4465",
  "company-details-components": "/company-details-components/static-1.6685",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1031",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16571",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3938",
  "social-insights-client-types": "/social-insights-client-types/static-1.22939",
  "utility-belt": "/utility-belt/static-1.3016",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24213",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8253",
  "customer-data-rte": "/customer-data-rte/static-1.33909",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6542",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5583",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39178",
  "crm_universal": "/crm_universal/static-1.22733",
  "customer-data-email": "/customer-data-email/static-1.18649",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.550",
  "universal-associations-select": "/universal-associations-select/static-1.11574",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10466",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37237",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16677",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.242",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57373",
  "hub-http-contrib": "/hub-http-contrib/static-1.3511",
  "interframe": "/interframe/static-3.5220",
  "tinymce-data": "/tinymce-data/static-1.41488",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5680",
  "layout-dnd-components": "/layout-dnd-components/static-1.13236",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12211",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16960",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8097",
  "company-details-service-types": "/company-details-service-types/static-1.4423",
  "segments-query-core": "/segments-query-core/static-1.1909",
  "pricing-pages-api": "/pricing-pages-api/static-1.16436",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "draft-content-plugins": "/draft-content-plugins/static-1.29164",
  "sequences-lib": "/sequences-lib/static-1.8795",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "meetings-client-types": "/meetings-client-types/static-1.4067",
  "meetings-core": "/meetings-core/static-1.772",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9369",
  "ContentData": "/ContentData/static-1.69558",
  "layout-data-lib": "/layout-data-lib/static-1.10536",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8652",
  "advanced-menus-core": "/advanced-menus-core/static-1.15823",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12574",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35203",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15822",
  "simple-menus-lib": "/simple-menus-lib/static-1.17339"
}
};
